import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from '@tanstack/react-query';

import { SLAConfigData, SLARuleType } from '../@types/sla.type';
import { createSLAConfig, getAllSLAConfigs, updateSLAConfig } from '../api/sla';
import { SLAConfigsKey } from '../configs/sla';

export const useGetAllSLAConfigs = (): UseQueryResult<SLAConfigData[]> => {
  return useQuery({
    queryKey: [SLAConfigsKey],
    queryFn: () => getAllSLAConfigs(),
  });
};

// SLA config creation data - matches what the API expects
interface SLAConfigCreateData extends Partial<SLARuleType> {
  id?: number;
  name?: string;
  scope?: string;
  serviceType?: string[];
  actionType?: string[];
  processType?: string[];
  priority?: string[];
  region?: string[];
  targetType?: string;
  slaType?: string;
  slaTypeValue?: string;
  notes?: string;
  ph?: boolean;
  isActive?: boolean;
  client?: string[];
  contract?: string[];
  brand?: string[];
  isServiceWindow?: boolean;
  targetTypeOnStatusChangeStatuses?: string[];
}

// SLA config update data - requires id
interface SLAConfigUpdateData extends SLAConfigCreateData {
  id: number;
}

export const useCreateSLAConfig = (): UseMutationResult<
  SLAConfigData,
  Error,
  SLAConfigCreateData
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SLAConfigCreateData) => {
      return await createSLAConfig(data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [SLAConfigsKey],
      });
    },
  });
};

export const useUpdateSLAConfig = (): UseMutationResult<
  SLAConfigData,
  Error,
  SLAConfigUpdateData
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: SLAConfigUpdateData) => updateSLAConfig(data.id, data),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [SLAConfigsKey],
      });
    },
  });
};
